import React from "react";
//#region types
//#endregion
//#region components
import { Select, SelectChangeEvent, SelectProps } from "@mui/material";
//#endregion

const ControlledSelect: React.FC<SelectProps<string | number>> = (props) => {
  const [open, setOpen] = React.useState<boolean>(false);

  const onChange = (event: SelectChangeEvent<string | number>, child: React.ReactNode) => {
    props.onChange && props.onChange(event, child);
    setOpen(false);
  };

  return (
    <Select
      {...props}
      open={open}
      onChange={onChange}
      onClick={() => {
        open ? setOpen(false) : setOpen(true);
      }}
      MenuProps={{
        hideBackdrop: true,
        disablePortal: true,
      }}
    >
      {props.children}
    </Select>
  );
};

export default ControlledSelect;
